import { Show, SimpleShowLayout } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import { useLocation, useParams } from "react-router-dom";
import { CURRICULUMS, MODULES, StudentServicePath } from "utils/constants";
import InfoSection from "./InfoSection";

const ShowModule = () => {
  const location = useLocation();
  const module = location.state?.module;
  const curriculumName = location.state?.curriculumName;
  const { id } = useParams();

  return (
    <Show
      title={`Детайли за модул за учебен план: ${curriculumName}`}
      resource={`${StudentServicePath}${CURRICULUMS}/${id}/${MODULES}`}
      id={module?.id}
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <InfoSection />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowModule;
